import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers, FormikProps } from "formik";
import { setDateFilter, setBatches } from "src/redux/slices/UpComeingPaymentsSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import UpComeingPaymentsFilterCard from "./UpComeingPaymentsFilterCard";

type Props = {
  onClose: () => void;
};

export type UpComeingPaymentsFilterCardValues ={
    startDate: any;
    endDate: any;
    batchs: any;
}

const UpComeingPaymentsFilterCardWrapper = ({ onClose }: Props) => {
  const dispatch = useDispatch();
  const { dateFilter , batches } =
  useSelector((state: RootState) => state.upComeingPayments);

  // Form Initial Values
  const initialValues: UpComeingPaymentsFilterCardValues = {
    startDate: dateFilter?.start_date || null,
    endDate:dateFilter?.end_date || null,
    batchs:{
        label:batches?.label ,
        value:batches?.value
      },
  };
 

  // Handle Submit
  const handleSubmit = (
    values: UpComeingPaymentsFilterCardValues,
    { setSubmitting, resetForm }: FormikHelpers<UpComeingPaymentsFilterCardValues>
  ) => {
    dispatch(
      setDateFilter({
        start_date: values?.startDate,
        end_date: values?.endDate,
      })
    );
   dispatch(setBatches(values?.batchs))
   setSubmitting(false) 
   onClose()
  };
  const handleReset = (formikProps: FormikProps<UpComeingPaymentsFilterCardValues>) => {
    dispatch(setDateFilter({
      start_date:null,
      end_date: null,
    })) ;
    dispatch(setBatches([])) ;}

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
       
      >
        {(formikProps) => (
          <Form>
            <UpComeingPaymentsFilterCard formikProps={formikProps} onClose={onClose}  onReset={handleReset}  />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default UpComeingPaymentsFilterCardWrapper;
